import { createIcon } from '@chakra-ui/icons';

export const TrackFile = createIcon({
  displayName: 'TrackFile',
  viewBox: '0 0 20 20',
  path: [
    <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none">
      <rect width="20" height="20" rx="10" fill="#FDE9C8" />
      <g clipPath="url(#clip0_308_4088)">
        <path
          d="M7.50033 7.08398H14.167V14.584H7.50033V7.08398Z"
          stroke="#977334"
          strokeWidth="0.83"
          strokeMiterlimit="10"
          strokeLinecap="square"
        />
        <path
          d="M12.917 5.41797H5.83366V13.7513"
          stroke="#977334"
          strokeWidth="0.83"
          strokeMiterlimit="10"
          strokeLinecap="square"
        />
      </g>
      <defs>
        <clipPath id="clip0_308_4088">
          <rect width="10" height="10" fill="white" transform="matrix(-1 0 0 1 15 5)" />
        </clipPath>
      </defs>
    </svg>,
  ],
});
